import { required, email, helpers, and, or } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import type { Validator } from '../types';
import { TValidatorMessage } from '../utils';
import qicValidators from '../validators/qicValidators';
// TODO: create one interface for any validation system. Add raw common validators like required, email, maxLength etc. Vuelidate exports only withMessage validators

export const useVuelidateValidators = () => {
  const { withMessage } = helpers;

  function getVuelidateQicValidator (qicValidator: Validator, messageParams: { [key in string]: string } = {}) {
    // We can also set vuelidate withMessage validators here to set message what we need.
    return withMessage(TValidatorMessage(qicValidator, messageParams), qicValidator.validator)
  }

  const getCommonRules = () => ({
    email: withMessage(TValidatorMessage({ message: 'Email is invalid', messageT: 'qic.error.email.invalid' }), email),
    required: withMessage(TValidatorMessage({ message: 'Fill in the field', messageT: 'qic.error.fill_field' }), required)
  })
  
  const getPhoneRules = () => ({
    phoneLength11: getVuelidateQicValidator(qicValidators.phoneLength11),
    phoneMinLengthRebranding: getVuelidateQicValidator(qicValidators.phoneMinLengthRebranding),
    phoneLessDigits: getVuelidateQicValidator(qicValidators.phoneLessDigits),
    phoneStartsWith3567: getVuelidateQicValidator(qicValidators.phoneStartsWith3567),
    phoneCompleted: getVuelidateQicValidator(qicValidators.phoneCompleted),
    phoneLengthBetween7and13: getVuelidateQicValidator(qicValidators.phoneLengthBetween7and13),
  })

  const getQidRules = () => ({
    qidLength11: getVuelidateQicValidator(qicValidators.qidLength11),
    qidStartsWith23: getVuelidateQicValidator(qicValidators.qidStartsWith23),
  })

  const getNameRules = () => ({
    fullNameAllowedCharacters: getVuelidateQicValidator(qicValidators.fullNameAllowedCharacters),
  })

  return {
    getCommonRules,
    getPhoneRules,
    getQidRules,
    getNameRules,
    and,
    or,
    createRule: getVuelidateQicValidator,
  };
};

export const useVuelidateValidation = useVuelidate;
